import { selectMerchant } from "@redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import styled from "styled-components";
import {
    FooterBooking,
    FooterCard,
    FooterHome,
    FooterLoyalty,
    FooterShop,
    FooterUser,
} from "./icon";

export const ComponentFooter = () => {
    const { themes } = useSelector(selectMerchant);

    const { pathname } = useLocation();
    return (
        <StyledFooter themeColor={themes?.themeColor!}>
            <div className="menu-item">
                <div className="icon-div">
                    <FooterHome />
                </div>
                <p>Home</p>
            </div>
            <div className="menu-item">
                <div className="icon-div">
                    <FooterBooking />
                </div>
                <p>Booking</p>
            </div>
            <div className="menu-item">
                <div className="icon-div">
                    <FooterShop />
                </div>
                <p>Shop</p>
            </div>
            <div className="menu-item">
                <div className="icon-div">
                    <FooterLoyalty />
                </div>
                <p>Loyalty</p>
            </div>
            <div className="menu-item">
                <div className="icon-div">
                    <FooterCard />
                </div>
                <p>Card</p>
            </div>
            <div className="menu-item">
                <div className="icon-div">
                    <FooterUser />
                </div>
                <p>User</p>
            </div>
        </StyledFooter>
    );
};

const StyledFooter = styled.div<{ themeColor: string }>`
    background-color: ${(p) => p.theme.colors.background};
    width: 100%;
    position: fixed;
    bottom: 8px;
    width: 480px;
    max-width: 100vw;
    display: flex;
    justify-content: space-around;
    height: 70px;
    box-shadow: 0px 0px 8px rgba(175, 175, 175, 0.14);
    .menu-item {
        padding: 5px;
        text-align: center;
        color: #919191;
        cursor: pointer;
        .icon-div {
            height: 35px;
        }
    }
`;
